<div>
  <app-list-table
    [isLoading]="!!(isLoading | async)"
    [numberOfItems]="(totalProducts | async) ?? 0"
    [columns]="displayedColumns"
    [rowIdName]="'packagingUnitId'"
    [dataSource]="productTableSource"
    [defaultStatus]="contentStatus.Draft"
    [customCellValue]="getCellValue"
    [customCellTooltip]="getCellTooltip"
    [pageSizeOptions]="pageSizeOptions"
    [pageSize]="pageSize"
    [routeBase]="'products'"
    (sortChangedEvent)="handleSortChanged($event)"
  >
    <ng-template let-id>
      <a
        mat-icon-button
        color="primary"
        class="filled ms-3"
        [routerLink]="[
          '/selling/sortiment/product-sortiment/products-start/products/edit'
        ]"
        [queryParams]="{ id: id }"
        [matTooltip]="'SHARED.EDIT' | translate"
      >
        <mat-icon>edit</mat-icon>
      </a>
    </ng-template>
  </app-list-table>
</div>
